(function () {

  'use strict';

  function pxWorkflowImageProcessing($rootScope, IMAGE_ROTATION) {
    return {
      restrict: 'E',
      scope: {
        me: '=me',
        tenant: '=tenant',
        workflowFormModel: '='
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/imageProcessing/workflowImageProcessing.template.html',
      link: function (scope, element, attrs) {

        scope.selectPlaceHolder = 'Select';

        scope.setItemOnModel = function (item, model, attr) {
          scope.workflowFormModel[model][attr] = item.id;
        };

        function setSelectOptions() {
          scope.IMAGE_PROCESSING_SETTINGS = {
            setting: {
              IMAGE_ROTATION: IMAGE_ROTATION.find(item => item.id === scope.workflowFormModel.imageProcessing.rotation)
            },
            selectable: {
              IMAGE_ROTATION
            }
          };
        }

        setSelectOptions();
      }
    };
  }

  pxWorkflowImageProcessing.$inject = ['$rootScope', 'IMAGE_ROTATION'];

  angular
    .module('printix-admin')
    .directive('pxWorkflowImageProcessing', pxWorkflowImageProcessing);

})();
